import { getRightLabel } from "../account/rightCatalog";

const GRADE_PRIORITY = [3, 4, 5, 6];

const RIGHT_ORDER = [
  "PriceMonthlyCents",
  "AnnualDiscountPercent",
  "TrialDurationDays",
  "VehiculeMaxActive",
  "VehiculeMaxSold",
  "ProMemberMax",
  "AttachmentMaxPerItem",
  "AttachmentMaxFileMb",
  "StatisticsBasic",
  "ActivityJournalScope",
  "VehicleComparison",
  "StatisticsAdvanced",
  "VehiculeCreate",
  "VehiculeUpdate",
  "VehiculeDelete",
  "ReleverCreate",
  "ReleverUpdateOwn",
  "ReleverUpdate",
  "ReleverDelete",
  "EntretienCreate",
  "EntretienUpdateOwn",
  "EntretienUpdate",
  "EntretienDelete",
  "MaintenanceAutoPlanning",
  "MaintenanceRuleCustomize",
  "DeletionRequest",
  "DataDownload",
  "MemberManage",
  "PaymentMethodManage",
];

const getRightOrder = (name) => {
  const index = RIGHT_ORDER.indexOf(name);
  return index === -1 ? Number.MAX_SAFE_INTEGER : index;
};

export const isUnavailableOfferRightValue = (row, right) => {
  if (!right) return true;

  const value = Number(right.Valeur);
  if (!Number.isFinite(value)) return true;
  if (row.name === "PriceMonthlyCents") return false;
  if (row.type === "PERMISSION") return value <= 0;
  return value === 0;
};

export const getOfferRightValueRank = (row, right) => {
  if (isUnavailableOfferRightValue(row, right)) return 2;
  return row.type === "PERMISSION" ? 1 : 0;
};

export const createOfferRightRows = (grades) => {
  const names = [...new Set(grades.flatMap((grade) => grade.Droits.map((right) => right.Nom)))];
  return names
    .map((name) => {
      const values = Object.fromEntries(
        grades.map((grade) => [grade.GradeID, grade.Droits.find((right) => right.Nom === name) || null])
      );
      const sample = Object.values(values).find(Boolean);
      return { name, type: sample?.Type || "PERMISSION", values };
    })
    .sort((left, right) => {
      for (const gradeId of GRADE_PRIORITY) {
        const rankDifference = getOfferRightValueRank(left, left.values[gradeId])
          - getOfferRightValueRank(right, right.values[gradeId]);
        if (rankDifference !== 0) return rankDifference;
      }

      const orderDifference = getRightOrder(left.name) - getRightOrder(right.name);
      if (orderDifference !== 0) return orderDifference;
      return getRightLabel(left.name).localeCompare(getRightLabel(right.name), "fr");
    });
};
